import { createFileRoute, redirect } from '@tanstack/react-router';

const SettingsIndexRoute = () => null;

export const Route = createFileRoute('/_authenticated/_app/settings/')({
  component: SettingsIndexRoute,
  beforeLoad: () => {
    throw redirect({ to: '/settings/profile' });
  },
});
